// Monthly Instalment Calculator – Belgium
// Counterpart of the Loan Simulator: same reference model, instalment formula and
// parameters, but it calculates the instalment from the loan amount.

import {
  BELGIUM_LOAN_PARAMS,
  MAX_TERM_YEARS,
  MIN_TERM_YEARS,
  annuity,
  round,
} from "../loan-simulator/LoanSimulatorBelgiumCalc";

export { MAX_TERM_YEARS, MIN_TERM_YEARS };

export function calculateInstalmentBelgium({ loanAmount, termYears, params = BELGIUM_LOAN_PARAMS }) {
  const L = Number(loanAmount);
  const N = Number(termYears);
  if (!(L > 0) || !Number.isInteger(N) || N < MIN_TERM_YEARS || N > MAX_TERM_YEARS) {
    return null;
  }

  const n = 12 * N;
  const i = params.monthlyInterestRate;

  // Step 1 – monthly instalment
  const A = annuity(L, n, i);

  // Step 2 – totals (with a zero rate the last instalment repays the remaining balance)
  const totalRepaid = i === 0 ? L : round(n * A, 2);
  const totalInterest = i === 0 ? 0 : round(n * A - L, 2);

  return {
    loanAmount: L,
    termYears: N,
    termMonths: n,
    monthlyInterestRate: i,
    annualInterestRate: Math.pow(1 + i, 12) - 1,
    instalment: A,
    totalRepaid,
    totalInterest,
    parameterVersion: params.version,
  };
}
